
import { call, put, select } from 'redux-saga/effects';
import queryString from 'query-string';
import geoViewport from '@mapbox/geo-viewport';
import { flatten } from 'lodash';
import { API } from '../../api';

export const getServerConfig = ({ serverConfig }) => serverConfig;
export const getQueryString = ({ querystring }) => querystring;
export const getDocumentLocationSearch = () => document.location.search;

export function* setInitialViewport() {
  const documentLocationSearch = yield select(getDocumentLocationSearch);
  yield put({
    type: 'STORE_QUERY_STRING',
    payload: queryString.parse(documentLocationSearch),
  });

  try {
    const query = yield select(getQueryString);
    if (!Object.keys(query).length) return;
    const serverConfig = yield select(getServerConfig);
    const path = `/initial/${serverConfig.namespace}`;
    const results = yield call(API, 'get', 'api', path);

    const viewport = geoViewport.viewport(flatten(results.data.bbox), [640, 480]);

    yield put({
      type: 'SET_MAP_SETTINGS',
      payload: {
        id: 'MAIN_MAP',
        settings: {
          center: {
            lng: viewport.center[0],
            lat: viewport.center[1],
          },
          zoom: viewport.zoom,
        },
      },
    });
  } catch (err) {
    console.log(err);
  }
}
